import React from "react";
import { useEntidade } from "../Hooks/EntidadeHook";

import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { app_base_url } from "../Utils/Urls";
import { Agua } from "../Pages/Agua";
import { Servicos } from "../Pages/Servicos";
import { IssAlvara } from "../Pages/IssAlvara";

export const Rotas = () => {
  const { usuario } = useEntidade();
  return (
    <Router>
      <Routes>
        <Route path={`${app_base_url}/:banco/agua`} element={<Agua />}></Route>
        <Route path={`${app_base_url}/:banco/servicos`} element={<Servicos />}></Route>
        <Route path={`${app_base_url}/:banco/iss-e-alvara`} element={<IssAlvara />}></Route>
      </Routes>
    </Router>
  );
};
